const prod = {
    url: {
        API_URL: 'https://park45.ca/parkue_backend/public/api/',
        googleSheet: "https://docs.google.com/spreadsheets/d/1r6EQlTfkyAxrrQFnvUv-g4E8bGvg9S5L2ttAEQDOqgg/edit?usp=sharing",
        googleKey : "AIzaSyDcPvfjCIqeUpGe8_IaI_-5rIZX9qtCUnI",
        spreadSheet : "https://docs.google.com/spreadsheets/d/1T1IRpKYHMBvpBjNRILHJxpKlz6hfsGNPAVa4OXAl74M/"
    }
};
const dev = {
    url: {
        API_URL: 'https://park45.ca/parkue_backend/public/api/',
        googleSheet: "https://docs.google.com/spreadsheets/d/1r6EQlTfkyAxrrQFnvUv-g4E8bGvg9S5L2ttAEQDOqgg/edit?usp=sharing",
        googleKey : "AIzaSyDcPvfjCIqeUpGe8_IaI_-5rIZX9qtCUnI",
        spreadSheet : "https://docs.google.com/spreadsheets/d/1T1IRpKYHMBvpBjNRILHJxpKlz6hfsGNPAVa4OXAl74M/"
    }
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;